import React from 'react';
import ReactDOM from 'react-dom';
import 'azure-maps-control/dist/atlas.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ThemeContext from './context/ThemeContext';
import ErrorBoundary from './components/shared/ErrorBoundary';

const rootEl = document.getElementById('root');
if (!rootEl) {
    document.body.innerHTML = '<div style="padding:24px;font-family:sans-serif">Root element #root not found.</div>';
} else {
    ReactDOM.render(
        <React.StrictMode>
            <ErrorBoundary>
                <ThemeContext>
                    <App />
                </ThemeContext>
            </ErrorBoundary>
        </React.StrictMode>,
        rootEl
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
